var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiming(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.369,
    height: 16.711,
    viewBox: "0 0 13.369 16.711",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "hourglass_top_FILL0_wght400_GRAD0_opsz48",
    d: "M11.259,19.458H18.11V16.8a3.547,3.547,0,0,0-.992-2.517,3.334,3.334,0,0,0-4.867,0,3.547,3.547,0,0,0-.992,2.517ZM8,20.711V19.458h2.005V16.8a4.972,4.972,0,0,1,.762-2.684,4.329,4.329,0,0,1,2.12-1.765,4.313,4.313,0,0,1-2.12-1.776,5.024,5.024,0,0,1-.762-2.695V5.253H8V4H21.369V5.253H19.363V7.885a4.974,4.974,0,0,1-.773,2.695,4.38,4.38,0,0,1-2.11,1.776,4.329,4.329,0,0,1,2.12,1.765,4.972,4.972,0,0,1,.762,2.684v2.653h2.005v1.253Z",
    transform: "translate(-8 -4)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiming);
export default __webpack_public_path__ + "static/media/timing.b432eb33186175e391f1a39e5ad0f8b9.svg";
export { ForwardRef as ReactComponent };